import api from "../Api";

const getAuthHeaders = () => {
  const token =
    localStorage.getItem("token") ||
    sessionStorage.getItem("token") ||
    null;

  return token ? { Authorization: `Bearer ${token}` } : {};
};


// ✅ AI Agent - Make Drink
export const makeDrink = async (payload) => {
  const headers = {
    ...getAuthHeaders(),
    Accept: "application/json",
  };

  try {
    const res = await api.post(
      `/agent/make-drink`,
      payload,
      {
        headers,
        params: {
          api_password: "AI_Pos_passCode2026",
        },
      }
    );

    return res.data;
    /*
      expected response:
      {
        data: {...},
        message: "..."
      }
    */
  } catch (error) {
    const serverData = error?.response?.data;
    if (serverData?.message) throw new Error(serverData.message);
    throw error;
  }
};
export const makeDrinkUser = async (payload) => {
  const headers = {
    ...getAuthHeaders(),
    Accept: "application/json",
  };

  try {
    const res = await api.post(
      `/genrate-drink`,
      payload,
      {
        headers,
        params: {
          api_password: "AI_Pos_passCode2026",
        },
      }
    );

    return res.data;
    /*
      expected response:
      {
        data: {...},
        message: "..."
      }
    */
  } catch (error) {
    const serverData = error?.response?.data;
    if (serverData?.message) throw new Error(serverData.message);
    throw error;
  }
};
// ✅ Approve / Reject Drink
export const approveDrink = async (drinkId, approved, type) => {
  const headers = {
    ...getAuthHeaders(),
    Accept: "application/json",
  };

  const formData = new FormData();
  formData.append("approved", approved); // 1 أو 0
  formData.append("type", type); // client أو local_screen

  try {
    const res = await api.post(
      `/agent/approve-drink/${drinkId}`,
      formData,
      {
        headers,
        params: {
          api_password: "AI_Pos_passCode2026",
        },
      }
    );

    return res.data;
    /*
      expected:
      {
        message: "Drink approved and added to order",
        drink_id: 11
      }
    */
  } catch (error) {
    const serverData = error?.response?.data;
    if (serverData?.message) throw new Error(serverData.message);
    throw error;
  }
};

// ✅ Make Drink Public
export const makeDrinkPublic = async (drinkId) => {
  const headers = {
    ...getAuthHeaders(),
    Accept: "application/json",
  };

  try {
    const res = await api.get(
      `/agent/make/drink/is/public/${drinkId}`,
      {
        headers,
        params: {
          api_password: "AI_Pos_passCode2026",
        },
      }
    );

    return res.data;
    /*
      expected:
      {
        data: null,
        message: "تم نشر المشروب بنجاح"
      }
    */
  } catch (error) {
    const serverData = error?.response?.data;
    if (serverData?.message) throw new Error(serverData.message);
    throw error;
  }
};

